import moment from "moment"

/**
 * 是否为空
 * @param {Object | Array} target
 * @returns {Object | Array}
 */
const $isEmpty = function(val) {
  // null or undefined
  if (val == null) return true;

  if (typeof val === "boolean") return false;

  if (typeof val === "number") return !val;

  if (val instanceof Error) return val.message === "";

  switch (Object.prototype.toString.call(val)) {
    // String or Array
    case "[object String]":
    case "[object Array]":
      return !val.length;

    // Map or Set or File
    case "[object File]":
    case "[object Map]":
    case "[object Set]": {
      return !val.size;
    }
    // Plain Object
    case "[object Object]": {
      return !Object.keys(val).length;
    }
    default:
      return false;
  }
};

/**
 * 删除字符串前后空格
 * @param {*} str
 */
const $trim = function(str) {
  str = str.replace(/^(\s|\u00A0)+/, '')
  for (var i = str.length - 1; i >= 0; i--) {
    if (/\S/.test(str.charAt(i))) {
      str = str.substring(0, i + 1)
      break
    }
  }
  return str
}

/**
 * 深拷贝
 */
export const $deepclone = function(data) {
  let type = $getObjectType(data)
  let obj
  if (type === 'array') {
    obj = []
    for (let i = 0, len = data.length; i < len; i++) {
      if (data[i]) {
        delete data[i].$parent
      }
      obj.push($deepclone(data[i]))
    }
  } else if (type === 'object') {
    obj = {}
    for (let key in data) {
      if (data) {
        delete data.$parent
      }
      obj[key] = $deepclone(data[key])
    }
  } else {
    // 不再具有下一层次
    return data
  }
  return obj
};

/**
 * 获取对象类型
 */
const $getObjectType = function(obj) {
  let toString = Object.prototype.toString
  let map = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Function]': 'function',
    '[object Array]': 'array',
    '[object Date]': 'date',
    '[object RegExp]': 'regExp',
    '[object Undefined]': 'undefined',
    '[object Null]': 'null',
    '[object Object]': 'object',
  }
  if (obj instanceof Element) {
    return 'element'
  }
  return map[toString.call(obj)]
}

/**
 * 创建A标签下载
 * @param {Object | Array} target
 * @returns {Object | Array}
 */
const $CreatDownload = function(file, FileName = "") {
  const url = window.URL.createObjectURL(
    new Blob([file], { type: "octet/stream" })
  );
  const a = document.createElement("a");
  document.body.appendChild(a);
  a.style.display = "none";
  a.href = url;
  a.download = FileName;
  a.click();
  setTimeout(() => {
    a.remove();
  }, 0);
};

/**
 * localStroage
 */
const $setLocalStorage = function(key, value) {
  window.localStorage.setItem(key, JSON.stringify(value));
};
const $getLocalStorage = function(key) {
  return JSON.parse(window.localStorage.getItem(key) || null);
};
const $removeLocalStorage = function(key) {
  window.localStorage.removeItem(key);
};
const $clearLocalStorage = function() {
  window.localStorage.clear();
};

let $store = null;
const $saveStoreInstance = function(store) {
  $store = store;
};
const $getStoreInstance = function() {
  return $store;
};
// 部门级联数据格式函数
const $departmentListFactory = function(data){
  data.map(item =>{
    item.lable = item.name;
    item.value = item.id;
    if(item.children&&item.children.length){
      $departmentListFactory(item.children)
    }
  })
  return data
}

// 获取过去30天
const $getPassFormatDate = function(num) {
  var nowDate = new Date();
  var date = new Date(nowDate);
  date.setDate(date.getDate()-num);
  var seperator1 = "-";
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  if (month >= 1 && month <= 9) {
      month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
  }
  var currentdate = year + seperator1 + month + seperator1 + strDate;
  return currentdate;
}

const $formatChartTooltip = function(params){
  let spliceStr = `<span style='font-size: 14px;'>${params[0].axisValueLabel}</span><br>`
  const allData = params || []
  if(allData && allData.length > 0){
    allData.forEach((item) =>{
      const rangeParams = item.data.dateRang || {};
      let range = {}
      if(item.isDiff) {
        range.from = rangeParams.diffFrom;
        range.to = rangeParams.diffTo;
      }else {
        range.from = rangeParams.from;
        range.to = rangeParams.to;
      }
      spliceStr += `<span">${item.marker} ${item.name || item.seriesName}${item.data?.symbol?`(${item.data.symbol})`:''}</span>`+`<span style='float:right;margin-left: 10px;'>${item.value}</span><br>`
    })
  }
  return spliceStr;
}
const $getThousandths = function(val) {
  let str = typeof val === 'string' ? val : `${val}`
  return str.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
const $fixedMath = function(num, n = 2){
  // let num = Math.round(val * 100) / 100;
  // console.log(typeof num)
  var f = parseFloat(num);
    if(isNaN(f)){
      return false;
    }   
    f = Math.round(num*Math.pow(10, n))/Math.pow(10, n); // n 幂   
    var s = f.toString();
    var rs = s.indexOf('.');
    //判定如果是整数，增加小数点再补0
    if(rs < 0){
        rs = s.length;
        s += '.'; 
    }
    while(s.length <= rs + n){
        s += '0';
    }
    // return s;
  return $getThousandths(s);
}

const $fixedMathDigits = function(num, n = 2){
  // let num = Math.round(val * 100) / 100;
  console.log(typeof num)
  var f = parseFloat(num);
    if(isNaN(f)){
      return false;
    }   
    f = Math.round(num*Math.pow(10, n))/Math.pow(10, n); // n 幂   
    var s = f.toString();
    var rs = s.indexOf('.');
    //判定如果是整数，增加小数点再补0
    if(rs < 0){
        rs = s.length;
        s += '.'; 
    }
    while(s.length <= rs + n){
        s += '0';
    }
    return s;
  // return $getThousandths(s);
}

const $once = function(fn) {
  var flag = false
  return function() {
    if(!flag) {
      flag = true
      fn.call(this,...arguments)
    }
  }
}
const $objToOne = function(obj) {
  let tmpData = {}
  for (let index in obj) {
    if (typeof obj[index] == 'object' && !$isArrayFn(obj[index])) {
      let resObj = $objToOne(obj[index])
      Object.assign(tmpData, resObj) // 这里使用对象合并
    } else {
      tmpData[index] = obj[index]
    }
  }
  return tmpData
}
const $isArrayFn = function(value) {
  if (typeof Array.isArray === "function") {
    return Array.isArray(value);
  } else {
    return Object.prototype.toString.call(value) === "[object Array]";
  }
}
export const $getUuid = function(len, radix) {
  var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');

  var uuid = [], i;

  radix = radix || chars.length;
  if (len) {
    // Compact form
    for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random()*radix];
  } else {
    // rfc4122, version 4 form
    var r;
    // rfc4122 requires these characters
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
    uuid[14] = '4';
    // Fill in random data.  At i==19 set the high bits of clock sequence as
    // per rfc4122, sec. 4.1.5
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | Math.random()*16;
        uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
      }
    }
  }
  return uuid.join('');
}

const $timeSelectorToDate = function(val) {
  let value = []
  switch (val) {
    case 'T_DAY':
      value = [moment(), moment()]
      break;
    case 'Y_DAY':
      value = [moment().subtract(1, 'days'), moment().subtract(1, 'days')]
      break;
    case 'DBY_DAY':
      value = [moment().subtract(2, 'days'), moment().subtract(2, 'days')]
      break;
    case 'L_SEVEN_DAY':
      value = [moment().subtract(7, 'days'), moment().subtract(1, 'days')]
      break;
    case 'L_TWO_WEEK':
      value = [moment().subtract(14, 'days'), moment().subtract(1, 'days')]
      break;
    case 'MONTH':
      value = [moment().startOf('month'), moment()]
      break;
    case 'L_MONTH':
      value = [moment().subtract(1, 'months').startOf('month'), moment().subtract(1, 'months').endOf('month'), val]
      break;
  }
  value = value[0].format?[value[0].format('YYYY-MM-DD'), value[1].format('YYYY-MM-DD')]:value
  return value
}

const $isNotNull = function(val) {
  return !$isNull(val)
}

const $isNull = function(val) {
  // 特殊判断
  if (val instanceof Array && val.length === 0) {
    return true
  } else if (val instanceof Object) {
    val = $deepclone(val)
    delete val.$parent
    for (let o in val) {
      return false
    }
    return true
  } else if (val === 'null' || val == null || val === 'undefined' || val === undefined || val === '') {
    return true
  }
  return false
}

export default {
  $deepclone,
  $getObjectType,
  $isEmpty,
  $trim,
  $CreatDownload,
  $setLocalStorage,
  $getLocalStorage,
  $removeLocalStorage,
  $clearLocalStorage,
  $saveStoreInstance,
  $getStoreInstance,
  $departmentListFactory,
  $getPassFormatDate,
  $formatChartTooltip,
  $fixedMath,
  $fixedMathDigits,
  $getThousandths,
  $once,
  $getThousandths,
  $timeSelectorToDate,
  $getUuid,
  $objToOne,
  $isArrayFn,
  $isNotNull,
  $isNull
};
